import * as React from 'react';
import { cn } from '../../lib/utils';
import { tagVariant, typographyVariants } from './variants';
import type { TypographyProps } from './types';

export const Typography = React.forwardRef(
  <T extends React.ElementType>(
    {
      children,
      className,
      noWrap = false,
      tag = 'p' as T,
      variant: variantProp,
      ...rest
    }: TypographyProps<T>,
    ref: React.ForwardedRef<React.ComponentRef<T>>,
  ) => {
    const variant =
      variantProp ||
      tagVariant?.[tag.toString().toLowerCase() as keyof typeof tagVariant] ||
      'body-m';

    const noWrapClass = noWrap
      ? 'eye:truncate eye:overflow-hidden eye:text-ellipsis eye:whitespace-nowrap'
      : '';

    return React.createElement(
      tag,
      {
        ...rest,
        ref,
        className: cn(typographyVariants({ variant, className }), noWrapClass),
      },
      children,
    );
  },
);

Typography.displayName = 'Typography';
